import { apiClient } from "@/lib/api-client";
import type { ApiResponse } from "@/types/api";
import type { Section } from "../types";

/**
 * GETs the section list for a schedule. Sections are derived server-side from
 * the events grouping; the response includes `assignedCount` carried over
 * from the latest succeeded run (or `null` when no run exists yet).
 *
 * Mirrors {@link listScheduleIssues} / {@link listRuns}: unwraps the standard
 * {@link ApiResponse} envelope and throws on a `success = false` payload.
 */
export async function listSections(scheduleId: string): Promise<Section[]> {
  const response = await apiClient.get<ApiResponse<Section[]>>(
    `/schedules/${scheduleId}/sections`,
  );
  if (response.data.success) {
    return response.data.data;
  }
  throw new Error(response.data.message || "Failed to load sections");
}
